import { render, staticRenderFns } from "./ThePartnerSettingList.vue?vue&type=template&id=3cf8b592&scoped=true"
import script from "./ThePartnerSettingList.vue?vue&type=script&lang=ts"
export * from "./ThePartnerSettingList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf8b592",
  null
  
)

export default component.exports